import { render, staticRenderFns } from "./Collective.vue?vue&type=template&id=b21706d4&scoped=true"
import script from "./Collective.vue?vue&type=script&lang=js"
export * from "./Collective.vue?vue&type=script&lang=js"
import style0 from "./Collective.vue?vue&type=style&index=0&id=b21706d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21706d4",
  null
  
)

export default component.exports